import * as _ from 'underscore';
import { Modal } from './modal';
import { Event } from '..';
import { BaseForm } from '../ui/forms';
import { IEvent } from '../../interfaces';
import { KeyCode } from '../../enums';
import { FormModalOptions } from '../../interfaces/options';
import { DefaultFormModalOptions } from '../../const/defaultOptions';

export class FormModal extends Modal {
	public form: BaseForm;

	private okLabel: string;
	private clickOk: () => void;
	protected onOkClicked: Event<void>;
	public get OkClicked(): IEvent<void> {
		return this.onOkClicked;
	}

	constructor(options?: FormModalOptions) {
		super(
			(options = _.defaults({}, options, DefaultFormModalOptions, {
				keyBindings: [{ keyCode: KeyCode.ENTER, fn: () => this.clickOk() }]
			}))
		);

		this.okLabel = options.okLabel;
		this.form = options && options.form ? options.form : new BaseForm();

		this.form.ClickedSubmit.subscribe(() => {
			this.onOkClicked.notify();
			this.close();
		});

		this.onOkClicked = new Event<void>();

		this.clickOk = (): void => {
			this.form.submit();
		};

		this.Opened.subscribe(() => {
			setTimeout(() => {
				this.form.focus();
			}, 200);
		});
	}

	//overwrite
	public open(
		confirmCallBack?: (...args: any[]) => any,
		caller?: any,
		abortCallBack?: (...args: any[]) => any
	) {
		this.form.resetAllValues();
		this.form.hideValidationMessages();
		let confirmed: boolean = false;

		let _confirmCallBack = (...args: any[]) => {
			confirmed = true;
			if (confirmCallBack && caller) {
				confirmCallBack.apply(caller, args);
			}
		};

		let clearCallBack = (...args: any[]) => {
			this.OkClicked.unsubscribe(_confirmCallBack);
			this.Closed.unsubscribe(clearCallBack);
			if (!confirmed && abortCallBack && caller) {
				abortCallBack.apply(caller, args);
			}
		};

		this.OkClicked.subscribe(_confirmCallBack);
		this.Closed.subscribe(clearCallBack);
		super.open();
	}
}
